import { CITYGATE_ID, WHITELIST_DR } from 'Constants/appointment';

export const shouldEnableAppointment = (accountId, clinics) => {
  if (clinics?.length === 0) return false;
  const isCitygate = clinics?.map(e => +e.id).includes(CITYGATE_ID);
  return !isCitygate || (isCitygate && WHITELIST_DR.includes(+accountId));
};
